export default "__VITE_ASSET__CwY$V3ue__"